import { useEffect, useState } from 'react';
import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import NotificationHandler from '../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../utils/Enum';
import { ServerRequestPublic } from '../../../../utils/ServerDataRequest';
import Loader from '../../../shared/Loader/Loader';
import PreviewFileModal from '../../../shared/PreviewFile/PreviewFileModal';

const ImagePreview = ({ item, setItem, activeAccordion }) => {
    console.log("itemFile", item)
    const { handleFileChange, handleRemoveFile } = useNewItemChange(setItem, 'Viewer', activeAccordion);
    const API_URL_Wasabi = enumUtil.controller.Wasabi;

    const [imagePreview, setFilePreview] = useState('');
    const [dragActive, setDragActive] = useState(false);
    const [previewModalActive, setPreviewModalActive] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [FileType, setFileType] = useState('');
    const [FileToPreview, setFileToPreview] = useState('');

    useEffect(() => {
        if (item.file) {
            ViewPdf(item.file);
            setFilePreview(item.file)
        } else {
            setFilePreview('');
        }
    }, [item.file])

    const ViewPdf = (data) => {
        setFileType(null)
        setIsLoading(true)
        ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
            "BucketPath": data
            // "BucketPath": imagePreview
        }, 'Download').then((response) => {
            setIsLoading(false)
            setFileType(response.type);
            if (response.type === 'application/txt') {
                const blob = response;
                const reader = new FileReader();
                reader.onload = () => {
                    const content = reader.result;
                    setFileToPreview(content);
                };

                reader.readAsText(blob, 'utf-8');
            } else if (response.type === 'application/png') {
                const blob = response
                const objectURL = URL.createObjectURL(blob);
                setFileToPreview(objectURL)
            } else if (response.type === 'application/tiff') {
                const blob = response
                const objectURL = URL.createObjectURL(blob);
                setFileToPreview(objectURL)
            }
            else if (response.type === 'application/pdf') {
                const blob = response
                const objectURL = URL.createObjectURL(blob);
                setFileToPreview(objectURL)
            }
            else {
                let file = new Blob([response]);
                const fileUrl = URL.createObjectURL(file);
                setFileToPreview(fileUrl)
            }
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
        })
    }

    const openPopup = () => {
        setPreviewModalActive(true)
    }

    const onClose = () => {
        setPreviewModalActive(false)
    }

    let PreviewModal = "";
    if (previewModalActive) {
        PreviewModal = <PreviewFileModal modalActive={previewModalActive} onClose={onClose} item={FileToPreview} type={FileType} isLoading={isLoading} />
    }

    return (
        <>
            <div className="">
                {isLoading ? <Loader /> : null}
                {PreviewModal}
                <div className="sign-content d-flex align-items-center justify-content-center p-1" onClick={() => openPopup()}>
                    <img
                        src={FileToPreview}
                        alt="Image"
                    />
                </div>
                {/* : <>N/A</>} */}
            </div>
        </>
    )

}

export default ImagePreview;